import { render } from "./AttendanceToday.vue?vue&type=template&id=765846f2&ts=true"
import script from "./AttendanceToday.vue?vue&type=script&lang=ts"
export * from "./AttendanceToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__